import { useState } from "react";
import { BsPerson } from "react-icons/bs";
import { MdPhotoCamera } from "react-icons/md";

export default function ChangePhoto({ photo, currentAvatar }) {
  const [preview, setPreview] = useState(null);
  const [visibleHover, setVisibleHover] = useState(false);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const validImageTypes = ["image/jpeg", "image/png", "image/webp"];
      
      if (!validImageTypes.includes(file.type)) {
        setError("Por favor, selecione uma imagem válida (JPG, PNG, WEBP).");
        return;
      }
      setError(null);
      photo(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  return (
    <>
      <div className="container-photo mb-3">
        <div
          onMouseEnter={() => setVisibleHover(true)}
          onMouseLeave={() => setVisibleHover(false)}
          className="position-relative profile-container d-flex justify-content-center align-items-center bg-white rounded-circle"
          onClick={() => {
            document.getElementById("fileInput").click();
          }}
        >
          {preview ? (
            <img
              src={preview}
              alt="perfil"
              className="w-100 h-100 rounded-circle object-cover"
            />
          ) : currentAvatar ? (
            <img
              src={currentAvatar}
              alt="perfil"
              className="w-100 h-100 rounded-circle object-cover"
            />
          ) : (
            <>{!visibleHover && <BsPerson style={{ fontSize: "100px" }} />}</>
          )}

          <div className="position-absolute w-100 d-flex h-100 bottom-0 end-0 profile-overlay justify-content-center align-items-center rounded-circle">
            <MdPhotoCamera style={{ fontSize: "100px", color: "#dddddd80" }} />
          </div>
        </div>
      </div>
      <input
        type="file"
        accept="image/jpeg, image/png, image/webp"
        id="fileInput"
        className="d-none"
        onChange={handleFileChange}
      />
      {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
    </>
  );
}
